import { render, staticRenderFns } from "./SolicitacaoInventarioFormParecer.vue?vue&type=template&id=6eabc654"
import script from "./SolicitacaoInventarioFormParecer.vue?vue&type=script&lang=js"
export * from "./SolicitacaoInventarioFormParecer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports